import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../Services/RestAPIService";
import { useParams } from 'react-router-dom';
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';

const CatExercise = ({ t }) => {
  const { subid,slug } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({
    columns: [
      {
        label: t("ID"),
        field: "id",
        sort: "asc",
        width: 50,
      },
      {
        label: t("Name"),
        field: "exercise_name",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Active"),
        field: "status",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Image"),
        field: "image",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Add Video"),
        field: "addVideo",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Edit"),
        field: "edit",
        sort: "asc",
        width: 100,
      },

    ],
    rows: []
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [iscategory, setIscategory] = useState([]);


  const getUsersData = async (page) => {
    try {
      const usersData = await get(`exercise/exercises/?categories=${slug}&page=${page}&page_size=5`);

        const category = usersData?.results?.[0]?.categories?.find(cat => cat?.id === parseInt(slug));

        setIscategory(category)
        console.log(category,"category")


      const modifiedRows = usersData.results.map(row => ({
        ...row,

      }));

      setData(prevState => ({
        ...prevState,
        rows: modifiedRows
      }));
      setTotalPages(Math.ceil(usersData.count / 5)); // Assuming each page contains 5 records
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    getUsersData(currentPage);
  }, [currentPage]);

  const handleCheckboxChange = (id) => {
    const updatedSelectedRows = [...selectedRows];
    const index = updatedSelectedRows.indexOf(id);
    if (index === -1) {
      updatedSelectedRows.push(id);
    } else {
      updatedSelectedRows.splice(index, 1);
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleEdit = (id) => {
    console.log("Edit button clicked for exercise with ID:", id);
    navigate(`/category/edit-exercise/${subid}/${id}`);
    // Handle edit action here
  };
  const handleAddVideo = (id) => {
    // console.log("Edit button clicked for exercise with ID:", id);
    navigate(`/category/videos/${subid}/${slug}/${id}`);
    // Handle edit action here
  };

  const handleTableChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Home" title={t("Pain Area Body Parts")} titleLink={`/category/sub-category/${subid}`} breadcrumbItem={t("Exercises")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <CardTitle className="h4">{iscategory?.name} {t("Exercises")} Data</CardTitle>
                  <Button color="primary" onClick={() => { navigate(`/category/create-exercise/${subid}/${slug}`) }}>
                      <i className="typcn typcn-plus"></i> {t("Add New Exercise")}
                    </Button>
                  </div>

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging={false}
                    data={{
                      columns: data.columns,
                      rows: data.rows.map(row => ({
                        ...row,
                        select: <input type="checkbox" checked={selectedRows.includes(row.id)} onChange={() => handleCheckboxChange(row.id)} />,
                        image: <img src={row.image || "https://via.placeholder.com/50"} alt="Exercise" width="50" height="50" />,
                        edit: <Button color="secondary" onClick={() => handleEdit(row.id)}>{t("Edit")}</Button>,
                        addVideo: <Button color="primary" onClick={() => handleAddVideo(row.id)}>{t("Add Videos")}</Button>,
                        status: row.status ? t("True") : t("False"),
                      }))
                    }}
                  />
                  <nav aria-label='Page navigation example'>


                    <MDBPagination className='mt-3'>
                      <MDBPaginationItem disabled={currentPage === 1}>
                        <MDBPaginationLink onClick={() => handleTableChange(currentPage - 1)} tabIndex="-1" aria-disabled={currentPage === 1}>{t("Previous")}</MDBPaginationLink>
                      </MDBPaginationItem>
                      {[...Array(totalPages).keys()].map(page => (
                        <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                          <MDBPaginationLink onClick={() => handleTableChange(page + 1)}>
                            {page + 1}
                          </MDBPaginationLink>
                        </MDBPaginationItem>
                      ))}
                      <MDBPaginationItem disabled={currentPage === totalPages}>
                        <MDBPaginationLink onClick={() => handleTableChange(currentPage + 1)}>{t("Next")}</MDBPaginationLink>
                      </MDBPaginationItem>
                    </MDBPagination>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(CatExercise);
